<template>
  <yd-dialog
    :title="form.id ? '编辑' : '新增'"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="110px"
    >
      <el-form-item :label="type === 4 ? 'icon名称' : '广告名称'" prop="name">
        <el-input
          type="text"
          :placeholder="`不超过${type === 4 ? 5 : 10}个字`"
          v-model="form.name"
          :maxlength="type === 4 ? 5 : 10"
          show-word-limit
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item
        v-if="clientType === 1"
        :label="type === 4 ? '位置' : '广告位置'"
        prop="locationKey"
      >
        <el-select
          v-model="form.locationKey"
          placeholder="请选择"
          :disabled="type === 4"
          clearable
          style="width: 300px"
        >
          <el-option
            v-for="item in locationList"
            :key="item.advertisingLocationKey"
            :label="item.advertisingLocationDesc"
            :value="item.advertisingLocationKey"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="type === 3 || type === 4"
        :label="type === 4 ? '排序' : '权重'"
        prop="sort"
      >
        <el-input
          type="number"
          placeholder="请输入整数"
          v-model.number="form.sort"
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item label="活动时间" required>
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="开始日期"
          :picker-options="pickerOptionStart()"
          style="width: 200px"
        />
        <span>-</span>
        <el-date-picker
          v-model="form.endTime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="结束日期"
          :picker-options="pickerOptionEnd()"
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item v-if="type !== 1" label="图片" prop="imgUrl" required>
        <!-- <div v-if="type !== 4"> -->
        <div v-if="type !== 4 || clientType === 2">
          <upload-image
            :file="fileList"
            :instructionText="`jpg/png/gif格式，大小${imgSize[0]}*${imgSize[1]}，不超过500kb。`"
            @uploadSuccess="(url) => getImgUrl(url)"
            @remove="handleRemove('ios')"
            :width="imgSize[0]"
            :height="imgSize[1]"
            :fileSize="500"
            :code="codeType"
          />
        </div>
        <div v-else class="flex">
          <el-image
            v-if="form.imgUrl"
            style="width: 100px; height: 100px"
            :src="form.imgUrl"
            :preview-src-list="[form.imgUrl]"
          />
          <div class="margin-left-10">
            <el-button type="text" @click="changeImg">
              {{ form.imgUrl ? '更换图片' : '新增图片' }}
            </el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="clientType !== 1 && type === 1"
        label="Android图片"
        prop="imgUrl"
        required
      >
        <upload-image
          :file="androidFile"
          :instructionText="'jpg/png/gif格式，大小1080*1920，不超过500kb。'"
          @uploadSuccess="(url) => getImgUrl(url, 'android')"
          @remove="handleRemove('android')"
          :width="1080"
          :height="1920"
          :code="codeType"
        />
      </el-form-item>
      <el-form-item v-if="clientType !== 1 && type === 1" label="IOS图片" prop="imgUrl" required>
        <upload-image
          :file="iosFile"
          :instructionText="'jpg/png/gif格式，大小750*1334，不超过500kb。'"
          @uploadSuccess="(url) => getImgUrl(url, 'ios')"
          @remove="handleRemove('ios')"
          :width="750"
          :height="1334"
          :code="codeType"
        />
      </el-form-item>
      <el-form-item v-if="clientType !== 1 && type === 1" label="自定义图片">
        <el-button type="primary" @click="addCustom" v-if="customImage.length < 4">添加</el-button>
        <div style="display: flex; margin-top: 10px">
          <upload-image
            v-for="item in customImage"
            :key="item.uuid"
            :file="item.file"
            :instructionText="item.instructionText"
            @uploadSuccess="(url) => getImgUrl(url, 'custom', item)"
            @remove="handleRemove('custom', item)"
            :code="codeType"
          />
        </div>
      </el-form-item>
      <el-form-item label="跳转页面" :prop="type === 4 ? 'pageUrl' : ''">
        <el-input v-model.trim="form.pageUrl" placeholder="请输入链接" style="width: 300px" />
      </el-form-item>
      <el-form-item
        v-if="clientType === 1"
        label="跳转类型"
        :prop="type === 4 ? 'pageUrlType' : ''"
      >
        <el-radio-group v-model="form.pageUrlType">
          <el-radio :label="2">外部链接</el-radio>
          <el-radio :label="1">乘客端内部页面</el-radio>
          <el-radio :label="3">其他小程序（仅在微信小程序生效）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.pageUrlType === 3" label="APPID" prop="appId">
        <el-input v-model.trim="form.appId" placeholder="请输入APPID" style="width: 300px" />
      </el-form-item>
      <el-form-item v-if="form.pageUrlType === 3" label="账号原始ID" prop="appletOriginalId">
        <el-input
          v-model.trim="form.appletOriginalId"
          placeholder="请输入账号原始ID"
          style="width: 300px"
        />
      </el-form-item>
      <el-form-item v-if="clientType === 1" label="展示渠道" prop="displayChannelList">
        <el-checkbox-group v-model="form.displayChannelList">
          <el-checkbox label="1">微信小程序</el-checkbox>
          <el-checkbox label="2">APP</el-checkbox>
          <el-checkbox label="3">云闪付</el-checkbox>
          <el-checkbox label="4">支付宝小程序</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEdit">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
    <imageGallery
      v-if="imgShow"
      :visible="imgShow"
      @closeChoose="closeChoose"
      @saveImage="saveImage"
    />
  </yd-dialog>
</template>

<script>
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import { uuidv5 } from '@/util/util'
  import UploadImage from './upload-image'
  import { isEmpty } from 'lodash-es'
  import imageGallery from './image-gallery.vue'
  const codeMap = {
    1: 'advertising',
    2: 'popup',
    3: 'banner',
    4: 'icon-driver'
  }
  export default {
    components: {
      UploadImage,
      imageGallery
    },
    props: {
      type: {
        type: Number,
        default: 0 // 1为开屏页，2为弹窗，3为banner，4为icon
      },
      clientType: {
        type: Number,
        default: 0 // 1为乘客端，2为司机端，3为云滴管家
      },
      visible: {
        type: Boolean,
        default: false
      },
      locationList: {
        type: Array,
        default: () => []
      },
      advertisingInfo: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        pickerBeginOption: {
          disabledDate: (time) => {
            console.log(time)
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          }
        },
        doUpload: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        rules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          locationKey: [{ required: true, message: '请选择位置', trigger: 'change' }],
          pageUrl: [{ required: true, message: '请输入跳转页面', trigger: 'blur' }],
          pageUrlType: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
          displayChannelList: [
            { required: true, message: '请至少选择一个展示渠道', trigger: 'change' }
          ],
          sort: [
            { required: true, message: '请输入权重或排序', trigger: 'blur' },
            { pattern: /^(?:[1-9]|10)$/, message: '请输入小于等于10的正整数', trigger: 'blur' }
          ],
          appId: [
            { required: true, message: '请输入appId', trigger: 'blur' },
            { pattern: /^wx[a-z0-9]{16}/, message: 'appId输入有误', trigger: 'blur' }
          ],
          appletOriginalId: [
            { required: true, message: '请输入账号原始ID', trigger: 'blur' },
            { pattern: /^gh_[a-z0-9]{12}/, message: '账号原始ID输入有误', trigger: 'blur' }
          ]
        },
        form: {
          startTime: '',
          endTime: '',
          name: '',
          locationKey: '',
          imgUrl: '',
          pageUrl: '',
          appletOriginalId: undefined,
          displayChannelList: [],
          displayChannel: ''
        },
        uploadDisabled: false,
        fileList: [],
        androidImg: '',
        iosImg: '',
        customImage: [],
        androidFile: [],
        iosFile: [],
        showVisible: false,
        imgShow: false,
        ruleForm: null
      }
    },
    computed: {
      codeType() {
        return codeMap[this.type]
      },
      imgSize() {
        if (this.type === 2) {
          return [580, 760]
        }
        if (this.type === 4 && this.clientType === 1) {
          return [80, 80]
        }
        if (this.type === 4 && this.clientType === 2) {
          return [320, 140]
        }
        if (this.clientType === 1) {
          if (this.type === 3) {
            if (this.form.locationKey === 'client:002') {
              return [690, 210]
            }
            return [800, 420]
          }
        }
        if (this.clientType === 2) {
          return [750, 360]
        }
        if (this.clientType === 3) {
          return [682, 324]
        }
        return [580, 760]
      }
    },
    watch: {
      'form.displayChannelList': {
        handler: function (newValue, oldValue) {
          if (!isEmpty(newValue)) {
            this.form.displayChannel = newValue.join(',')
          }
        },
        deep: true
      }
    },
    mounted() {
      if (this.type === 4) {
        this.form.locationKey = 'client:001'
      }
      this.showVisible = this.visible
      if (!isEmpty(this.advertisingInfo)) {
        const { imgList, imgUrl } = this.advertisingInfo
        if (this.type === 1 && imgList) {
          this.androidFile.push({ url: imgList[0] })
          this.iosFile.push({ url: imgList[1] })
          this.uploadDisabled = true
          this.androidImg = imgList[0]
          this.iosImg = imgList[1]
          const customImage = imgList.slice(2)
          customImage.forEach((item) => {
            if (item) {
              const index = item.indexOf('?')
              const size = {}
              if (index !== -1) {
                const str = item.substr(index + 1)
                const strs = str.split('&')
                for (var i = 0; i < strs.length; i++) {
                  size[strs[i].split('=')[0]] = strs[i].split('=')[1]
                }
              }
              this.customImage.push({
                uuid: uuidv5(),
                height: size.height,
                width: size.width,
                url: item,
                instructionText: `${size.width} * ${size.height}`,
                file: [{ url: item }]
              })
            }
          })
        } else {
          this.fileList.push({ url: imgUrl })
        }
        this.form = {
          ...this.advertisingInfo,
          displayChannelList: []
        }
        if (this.form.displayChannel) {
          this.form.displayChannelList = this.form.displayChannel.split(',')
        }
        console.log('this.form.displayChannel', this.form)
      }
    },
    methods: {
      saveImage(url) {
        this.form.imgUrl = url
        this.closeChoose()
      },
      closeChoose() {
        this.imgShow = false
      },
      changeImg() {
        this.imgShow = true
      },
      pickerOptionStart() {
        return {
          // 日期限制
          disabledDate: (time) => {
            return Date.now() - 3600 * 1000 * 24 > time.getTime()
          }
        }
      },
      pickerOptionEnd() {
        if (!this.form.startTime) {
          return
        }
        return {
          // 日期限制
          disabledDate: (time) => {
            return time.getTime() < new Date(this.form.startTime).getTime() - 86400000
          }
        }
      },
      getImgUrl(url, type, item) {
        if (type === 'android') {
          this.androidImg = url
        }
        if (type === 'ios') {
          this.iosImg = url
        }
        if (type === 'custom') {
          item.url = url
          const index = url.indexOf('?')
          if (index !== -1) {
            const str = url.substr(index + 1)
            const strs = str.split('&')
            for (var i = 0; i < strs.length; i++) {
              item[strs[i].split('=')[0]] = strs[i].split('=')[1]
            }
          }
          item.instructionText = `${item.width} * ${item.height}`
        }
        if (!type) {
          this.form.imgUrl = url
        }
      },
      handleRemove(type, item) {
        if (type === 'android') {
          this.androidImg = ''
        }
        if (type === 'ios') {
          this.iosImg = ''
        }
        if (type === 'custom') {
          item.url = ''
          item.width = 0
          item.height = 0
        }
        if (!type) {
          this.form.imgUrl = ''
        }
      },
      save() {
        if (!this.form.startTime || !this.form.endTime) {
          this.$message.info('请先选择活动时间！')
          return
        }
        if (this.form.pageUrl) {
          this.form.pageUrl = this.form.pageUrl.replace(/\s+/g, '')
        }
        if (this.form.appId) {
          this.form.appId = this.form.appId.replace(/\s+/g, '')
        }
        if (this.clientType === 2) {
          this.form.locationKey = 'driver:001'
        }
        if (this.clientType === 3) {
          this.form.locationKey = 'oa:001'
        }
        if (this.type === 1) {
          if (!this.androidImg) {
            this.$message.info('请上传Android图片！')
            return
          }
          if (!this.iosImg) {
            this.$message.info('请上传IOS图片！')
            return
          }
          const img = this.customImage.map((item) => {
            return item.url
          })
          this.form.imgUrl = this.androidImg + ',' + this.iosImg
          if (img) {
            this.form.imgUrl = this.androidImg + ',' + this.iosImg + ',' + img.join()
          }
        }
        if (!this.form.imgUrl) {
          this.$message.info('请上传活动图片！')
          return
        }
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$emit('saveEdit', this.form)
          } else {
            return false
          }
        })
      },
      closeEdit() {
        this.showVisible = false
        this.uploadDisabled = false
        this.form = {
          startTime: '',
          endTime: '',
          name: '',
          locationKey: 'client:001',
          imgUrl: '',
          pageUrl: ''
        }
        this.androidFile = []
        this.iosFile = []
        this.fileList = []
        this.androidImg = ''
        this.iosImg = ''
        this.customImage = []
        this.$emit('closeEdit')
      },
      getImgSize(imgFile) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      },
      addCustom() {
        if (this.customImage && this.customImage.length >= 4) {
          this.$message.warning('自定义图片最多可上传4张！')
          return
        }
        this.customImage.push({
          uuid: uuidv5(),
          height: 0,
          width: 0,
          url: '',
          instructionText: ''
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
</style>
